/**
* 搜索
*/
import request, { MethodEnum, serverTriggerUrl } from '@/utils/fetch';
import { IThreadLisItem } from '@/api/thread/list';

export enum SEARCH_APIS {
  SEARCH_KEYWORDS = '/forum/search/recommend',
  SEARCH_THREAD = '/forum/search/thread',
}

export interface ISearchKeyWords {
  link: string;
  order: number;
  title: string;
}

export interface ISearchKeyWordsRes {
  items: ISearchKeyWords[];
}

export interface ISearchThreadReq {
  keyword: string;
  offset: number;
  limit: number;
  sortType?: string;
}

export interface IThreadListRese {
  items: IThreadLisItem[];
}

export const getSearchKeyWords = (isServerTrigger = false, headers = {}): Promise<ISearchKeyWordsRes['items']> => {
  const prefix = isServerTrigger ? serverTriggerUrl : '';
  const key = 'getSearchKeyWords';
  return request({
    isServerTrigger,
    key,
    headers,
    url: `${prefix}${SEARCH_APIS.SEARCH_KEYWORDS}`,
    method: MethodEnum.GET,
    params: {},
  }).then((data: ISearchKeyWordsRes) => data?.items || [])
  .catch((e) => []);
};

/* 根据用户输入的关键词 搜索帖子 */
export const getSearchThread = ({
  keyword,
  offset = 0,
  limit = 10,
  sortType,
}: ISearchThreadReq, isServerTrigger = false, headers = {}): Promise<IThreadListRese['items']> => {
  const prefix = isServerTrigger ? serverTriggerUrl : '';
  const key = 'GetSearchThread';
  return request({
    isServerTrigger,
    key,
    headers,
    url: `${prefix}${SEARCH_APIS.SEARCH_THREAD}`,
    method: MethodEnum.GET,
    params: {
      keyword,
      offset,
      limit,
      sortType,
    },
  }).then((data) => data?.items)
  .catch((e)=>{Promise.reject(e)});
};
